module.exports = __webpack_public_path__ + "static/chwinga-21e487e7c3aec8f93f73f0ce36fdebb1.png";